import { Component, OnInit, Input, NgZone, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PackageViewModel, CardTokenViewModel, StringViewModel, ConferenceViewModelWithDetails, PurchasePackageViewModel, RegistrationPackageViewModel, RegistrationFieldType, PackageRequirement, SurveyViewModel, OrganizationViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { NgForm } from '@angular/forms';
import { ConferenceCMSService, ConferenceSurveyService, EventService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';
import { Model } from 'survey-core';
import { ComponentCollection, Question } from 'survey-core';

import Enumerable from 'linq';
declare var fbq: any;
declare var gtag: any;
declare var ga: any;

@Component({
  selector: 'bxl-package-purchase-modal',
  templateUrl: 'package-purchase-modal.component.html',
})
export class PackagePurchaseModalComponent implements OnInit {
  initialized = false;
  submitComplete: Promise<{}> | undefined;
  public cardNumber: string;
  public showWorkshops: boolean;
  public expMo: string;
  public expYr: string;
  public cvv: string;
  public promoCode: string;
  public pronouns: string;
  public affiliation: string;
  public promoError: string;
  public errorMessage: string;
  public actualPrice: number;

  public tShirtSize: string;
  public isMember: boolean;
  public purchaseCEUs: boolean;
  @Input() packageId: number;
  @Input() conference: ConferenceViewModelWithDetails;
  @Input() organization: OrganizationViewModel;
  @ViewChild('theForm', { static: false }) public userFrm: NgForm;
  fullName: string;
  promoDiscount: number;
  promoDiscountAmount: number;
  startTimes: any[] = [];
  pckg: RegistrationPackageViewModel;
  PackageRequirement = PackageRequirement;
  RegistrationFieldType = RegistrationFieldType;
  reservedBreakouts: number[];
  survey: SurveyViewModel;
  surveyModel: Model;
  constructor(public activeModal: NgbActiveModal, private surveyService: ConferenceSurveyService, private cmsService: ConferenceCMSService, private eventService: EventService, private zone: NgZone, private auth: AuthenticationService, private toaster: ToasterService) {}

  ngOnInit(): void {
    var subscription = this.conference ? this.cmsService.getSingleRegistrationPackage(this.conference.id.toString(), this.packageId) : this.cmsService.getSingleRegistrationPackageForOrganization(this.organization.id.toString(), this.packageId);

    subscription.subscribe((result) => {
      this.pckg = result;
      this.pckg.addOns = Enumerable.from(this.pckg.addOns).orderBy((x) => x.name).toArray();

      if (this.pckg.customQuestionSurveyId) {
        this.loadSurvey();
      }

      this.actualPrice = this.pckg.price;
      this.affiliation = this.auth.user.affiliation;

      if (this.pckg.reserveBreakouts) {
        this.startTimes = Enumerable.from(this.pckg.courseEvents)
          .where((x) => x.currentBreakoutCount < x.breakoutCapacity)
          .orderBy((x) => x.startTime)
          .groupBy((x) => x.formattedFullTime)
          .where((x) => x.getSource().length > 1)
          .toArray();
        console.log(this.startTimes[0]);
        this.reservedBreakouts = new Array<number>(this.startTimes.length);
      }

      this.promoDiscount = 0;
      this.fullName = this.auth.user.firstName + ' ' + this.auth.user.lastName + ', ' + this.auth.user.credentials;
      console.log(this.auth.user.affiliation);
      this.initialized = true;
    });
  }

  loadSurvey() {
    this.surveyService.getSurveyById(this.conference.organizationId.toString(), this.conference.id, this.pckg.customQuestionSurveyId).subscribe((result) => {
      this.survey = result;
      const survey = new Model(JSON.parse(result.schemaJSON));
      //survey.onComplete.add(this.surveyComplete.bind(this));
      this.surveyModel = survey;
      this.surveyModel.isSinglePage = true;
      this.surveyModel.showNavigationButtons = false;
      this.surveyModel.questionsOnPageMode = 'singlePage';
      this.surveyModel.mode = 'edit';
      console.log(survey.getAllQuestions());
      this.updateQuestionsFromAuth();
      this.initialized = true;
    });
  }

  updateQuestionsFromAuth() {
    var questions = Enumerable.from(this.surveyModel.getAllQuestions());
    questions.forEach((question: Question) => {
      if (question.customQuestion?.name == 'bxlfirstname') {
        this.surveyModel.setValue(question.name, this.auth.user?.firstName);
      }

      if (question.customQuestion?.name == 'bxllastname') {
        this.surveyModel.setValue(question.name, this.auth.user?.lastName);
      }

      if (question.customQuestion?.name == 'bxlemail') {
        this.surveyModel.setValue(question.name, this.auth.user?.email);
      }

      console.log(question.customQuestion?.name);
    });
  }

  purchasePackageClicked() {
    console.log(this.reservedBreakouts);

    if (this.pckg.requirement.toString() == PackageRequirement[PackageRequirement.EDUAddress].toString() && this.auth.user.email.indexOf('.edu') == -1) {
      this.errorMessage = 'You must register with an .edu email address to purchase a student package.';
      return;
    }

    if (this.surveyModel?.hasErrors() || !this.userFrm.valid) {
      this.markAllTouched();
      this.errorMessage = 'There are some invalid or missing fields. Please fill out all required fields.';
      return;
    }

    this.errorMessage = '';

    let model = new PurchasePackageViewModel();
    model.cardToken = '';
    model.tShirtSize = this.tShirtSize;
    model.promoCode = this.promoCode;
    model.affiliation = this.affiliation;
    model.fullName = this.fullName;
    model.isMember = this.isMember;
    model.pronouns = this.pronouns;
    model.purchaseCEUs = this.purchaseCEUs;
    model.customSurveyJSON = JSON.stringify(this.surveyModel?.data);
    model.selectedAddOns = Enumerable.from(this.pckg.addOns)
      .where((x) => x.selected)
      .toArray();
    model.selectedEventAddons = Enumerable.from(this.pckg.eventAddons)
      .where((x) => x.selected)
      .toArray();

    model.customQuestionResponses = this.pckg.customRegistrationFields;
    model.reservedBreakouts = this.reservedBreakouts;

    this.submitComplete = new Promise((resetButton: any, reject) => {
      if (this.actualPrice > 0) {
        this.purchasePackage(resetButton, model);
      } else {
        this.completeFree(resetButton, model);
      }
    });
  }

  markAllTouched() {
    Object.keys(this.userFrm.controls).forEach((field) => {
      // {1}
      const control = this.userFrm.control.get(field);
      console.log(control); // {2}
      control.markAsTouched({ onlySelf: true });
      control.markAsDirty({ onlySelf: true }); // {3}
    });
  }

  calculatePrice() {
    if (this.isMember || !this.pckg.memberPricing) {
      console.log('is member');
      this.actualPrice = this.pckg.price;
    } else {
      this.actualPrice = this.pckg.nonMemberPrice;
    }

    if (this.purchaseCEUs && (this.isMember || !this.pckg.memberPricing)) {
      this.actualPrice += this.pckg.ceuPrice;
    } else if (this.purchaseCEUs && !this.isMember) {
      this.actualPrice += this.pckg.ceuNonMemberPrice;
    }

    console.log(this.actualPrice);

    if (this.promoDiscount > 0) {
      this.actualPrice = this.actualPrice - this.actualPrice * (this.promoDiscount / 100);
    }else if (this.promoDiscountAmount > 0){
      this.actualPrice = this.actualPrice - this.promoDiscountAmount;
    }else{
      this.actualPrice = this.actualPrice;
    }


    var addonPrice = Enumerable.from(this.pckg.addOns)
      .where((x) => x.selected)
      .sum((x) => x.price);
    this.actualPrice += addonPrice;

    var eventAddonPrice = Enumerable.from(this.pckg.eventAddons)
      .where((x) => x.selected)
      .sum((x) => {
        if (x.memberPricing && this.isMember) return x.memberPrice;
        return x.price;
      });

    var count = Enumerable.from(this.pckg.eventAddons)
      .where((x) => x.selected)
      .count();

    console.log(eventAddonPrice);

    if (this.pckg.eventAddonDiscountQuantityThreshold && count >= this.pckg.eventAddonDiscountQuantityThreshold) {
      var discountAmount = eventAddonPrice * this.pckg.eventAddonDiscountAmount;
      console.log(discountAmount);
      eventAddonPrice = eventAddonPrice - discountAmount;
    }

    this.actualPrice += eventAddonPrice;
  }

  applyPromoCode() {
    let model = new StringViewModel();
    model.value = this.promoCode;
    this.eventService.checkPackagePromoCode(this.pckg.id, model).subscribe(
      (result) => {
        this.promoError = '';
        this.promoDiscount = result.discountPercentage;
        this.promoDiscountAmount = result.discountAmount;
        this.calculatePrice();
      },
      (error) => {
        this.promoError = error.error;
        this.promoDiscount = 0;
        this.promoDiscountAmount = 0;
        this.calculatePrice();
      }
    );
  }

  completeFree(resetButton, model: PurchasePackageViewModel) {
    this.eventService.purchasePackage(this.pckg.id, model).subscribe(
      (result) => {
        if (!result) {
          resetButton();
          this.errorMessage = 'Unable to process transaction';
          return;
        }

        resetButton();
        this.activeModal.close();
        fbq('track', 'Purchase', { value: this.pckg.price, currency: 'USD' });
        gtag('event', 'conversion', {
          event_category: 'purchase',
          event_label: 'package',
          value: this.pckg.price,
        });
        gtag('event', 'conversion', {
          send_to: 'AW-10797976216/1tMrCOP-ov8CEJiV8Jwo',
          value: this.pckg.price,
          currency: 'USD',
          transaction_id: '',
        });

        console.log('here');
        this.toaster.messageDialog('Your purchase has been completed. You will receive a confirmation email shortly', 'Thank You!').subscribe();
      },
      (error) => {
        resetButton();
        this.errorMessage = error.error[0];
      }
    );
  }

  purchasePackage(resetButton, model: PurchasePackageViewModel) {
    let card = { number: this.cardNumber, exp_month: this.expMo, exp_year: this.expYr, cvc: this.cvv };
    (<any>window).Stripe.card.createToken(card, (status: number, response: any) => {
      if (status === 200) {
        model.cardToken = response.id;

        this.zone.run(() => {
          this.eventService.purchasePackage(this.pckg.id, model).subscribe(
            (result) => {
              if (!result) {
                resetButton();
                this.errorMessage = 'Unable to process transaction';
                return;
              }

              resetButton();
              this.activeModal.close();
              fbq('track', 'Purchase', { value: this.pckg.price, currency: 'USD' });
              gtag('event', 'conversion', {
                event_category: 'purchase',
                event_label: 'package',
                value: this.pckg.price,
              });
              gtag('event', 'conversion', {
                send_to: 'AW-10797976216/1tMrCOP-ov8CEJiV8Jwo',
                value: this.pckg.price,
                currency: 'USD',
                transaction_id: '',
              });
              console.log('here');
              this.toaster.messageDialog('Your purchase has been completed. You will receive a confirmation email shortly', 'Thank You!').subscribe();
            },
            (error) => {
              resetButton();
              this.errorMessage = error.error[0];
            }
          );
        });
      } else {
        resetButton();
        this.errorMessage = response.error.message;
      }
    });
  }
}
